import React, { useContext, useState } from 'react';
import { LanguageContext } from '@/App';

const Gallery = () => {
  const { language } = useContext(LanguageContext);
  const [selectedImage, setSelectedImage] = useState(null);

  const content = {
    en: {
      title: 'Photo Gallery',
      subtitle: 'Explore the spiritual essence through divine moments and sacred rituals',
    },
    hi: {
      title: 'फोटो गैलरी',
      subtitle: 'दिव्य पलों और पवित्र अनुष्ठानों के माध्यम से आध्यात्मिक सार का अन्वेषण करें',
    },
  };

  const images = [
    'https://static.wixstatic.com/media/4365ca_1258e0b08f274c79a07b3f2843068e73~mv2.png',
    'https://static.wixstatic.com/media/4365ca_f45e65c17f3047e891a809c561130ace~mv2.png',
    'https://static.wixstatic.com/media/4365ca_cbaff8dc125048b6b7d8cd248d5cba92~mv2.png',
    'https://static.wixstatic.com/media/4365ca_bb83f89730b8417bb60bcea35f53f61e~mv2.png',
    'https://static.wixstatic.com/media/4365ca_16fd2e4343254440b2ad87cb161cc158~mv2.png',
    'https://static.wixstatic.com/media/4365ca_76c89b072465419b9ff41f8dcef34acb~mv2.png',
    'https://static.wixstatic.com/media/4365ca_365888fd077245a4b15942731ad0a105f000.jpg',
    'https://static.wixstatic.com/media/4365ca_f4346a6e24e84219a9d64831086bd5b7f000.jpg',
  ];

  const t = content[language];

  return (
    <div className="animate-fade-in">
      {/* Hero */}
      <section className="hero-section py-20 px-4" data-testid="gallery-hero">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold gradient-text mb-6" data-testid="gallery-title">
            {t.title}
          </h1>
          <p className="text-base md:text-lg text-amber-800" data-testid="gallery-subtitle">{t.subtitle}</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((img, index) => (
              <div
                key={index}
                onClick={() => setSelectedImage(img)}
                className="cursor-pointer rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-72 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal for full-size image */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-modal"
        >
          <div className="relative max-w-6xl max-h-full">
            <button
              className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-amber-400 transition-colors"
              onClick={() => setSelectedImage(null)}
              data-testid="close-modal-btn"
            >
              ×
            </button>
            <img
              src={selectedImage}
              alt="Full size"
              className="max-w-full max-h-screen object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;